import Button from 'components/Forms/Button';
import { superAdminRoutes } from 'components/Routes/SuperAdmin';
import Table from 'components/Table';
import InputFilter from 'components/Table/InputFilter';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';
import { companyStore } from 'stores/CompanyStore';

const CompaniesTable = observer(() => {
    const [filter, setFilter] = useState<any>({});
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        companyStore.getCompanies();

        return () => {
            companyStore.resetStore();
        }
    }, [])

    const updateFilter = (key: string, value: string) => {
        const f = filter;
        f[key] = value;
        setFilter(f);


        companyStore.resetStore();
        companyStore.getCompanies(f);
    }

    const companies = companyStore.companies?.items || [];

    return (
        <>
            <Table
                onRowClicked={(item) => navigate(generatePath(superAdminRoutes.pageCompanyDetails, { id: item.id }))}
                defaultSortLabel='name'
                data={companies}
                render={[
                    {
                        label: t('name'),
                        cell: (item) => item.name,
                        appendToLabel: <InputFilter placeholder={`${t('search')}...`} onChange={(val) => updateFilter('byName', val)} />
                    },
                    {
                        label: t('companyCode'),
                        cell: (item) => item.companyCode,
                        appendToLabel: <InputFilter placeholder={`${t('search')}...`} onChange={(val) => updateFilter('byCode', val)} />
                    }
                ]}
            />
            {
                companyStore.companies?.pagination.hasNextPage &&
                <div className='text-center mt-4'>
                    <Button
                        type='button'
                        label={`${t('loadMore')}...`}
                        appearance='secondary'
                        onClick={() => companyStore.getCompanies()}
                    />
                </div>
            }
        </>
    )
})

export default CompaniesTable;